"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ThemeProvider_1 = __importDefault(require("@material-ui/core/styles/ThemeProvider"));
const theme_1 = require("../theme");
const theme_2 = require("../domain/model/theme");
function ThemeProvider(props) {
    const selectedTheme = react_redux_1.useSelector((state) => state.appState.selectedTheme);
    const useSystemTheme = selectedTheme === theme_2.SelectedTheme.SystemDefault;
    const isSystemDarkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const shouldDarkModeBeActive = isDarkModeSelected();
    const [darkMode, setDarkMode] = react_1.useState(shouldDarkModeBeActive);
    if (darkMode !== shouldDarkModeBeActive) {
        setDarkMode(shouldDarkModeBeActive);
    }
    function isDarkModeSelected() {
        return selectedTheme === theme_2.SelectedTheme.Dark ||
            (selectedTheme === theme_2.SelectedTheme.SystemDefault && isSystemDarkModeQuery.matches);
    }
    function setDarkModeBasedOnSystemTheme() {
        const isSystemDarkMode = isSystemDarkModeQuery.matches;
        setDarkMode(isSystemDarkMode);
    }
    react_1.useEffect(() => {
        if (useSystemTheme) {
            isSystemDarkModeQuery.addEventListener("change", setDarkModeBasedOnSystemTheme);
            return () => isSystemDarkModeQuery.removeEventListener("change", setDarkModeBasedOnSystemTheme);
        }
    }, [useSystemTheme]);
    return (react_1.default.createElement(ThemeProvider_1.default, { theme: darkMode ? theme_1.darkTheme : theme_1.lightTheme }, props.children));
}
exports.default = ThemeProvider;
